module.exports = __webpack_public_path__ + "images/pro/icon-pro-huge@2x-44901f635a74b3ce32588408591ae268.png";